import { EffectDefs } from './EffectDefs';
import { Points } from './Points';
import { Content } from './Content';
import style from './SvgCanvas.module.scss';
import { MousePosition } from '@react-hook/mouse-position/src';
import { DataLines } from './DataLines';
import { ModuleContextProvider } from './ModulesContext';
import { Flashes } from './Flashes';
import { useDashboardContext } from '../DashboardContext';
import React from 'react';
import useGetRefSize from '../../../hooks/useGetRefSize';

const MemoizedPoints = React.memo(Points);
const MemoizedDataLines = React.memo(DataLines);
const MemoizedFlashes = React.memo(Flashes);

const SvgCanvasContent = React.memo(({ isDashboardAnimationsEnabled }: { isDashboardAnimationsEnabled: boolean }) => {
    return (
        <>
            <MemoizedPoints />
            <MemoizedDataLines />
            {isDashboardAnimationsEnabled && <MemoizedFlashes />}
        </>
    );
});

type SvgCanvasProps = {
    mouse: MousePosition;
    containerElement: React.MutableRefObject<null | HTMLElement>;
};

export const SvgCanvas = ({ mouse, containerElement }: SvgCanvasProps) => {
    const { isDashboardAnimationsEnabled } = useDashboardContext();
    const { width, height } = useGetRefSize(containerElement, 0);

    return (
        <ModuleContextProvider>
            <svg
                viewBox={`0 0 ${width} ${height}`}
                className={style.svg}
                width="100%"
                height="100%"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <EffectDefs />
                <SvgCanvasContent isDashboardAnimationsEnabled={isDashboardAnimationsEnabled} />
                <Content mouse={mouse} />
            </svg>
        </ModuleContextProvider>
    );
};
